import './ChecklistModal.scss';
class ChecklistModalController {
    static $inject = ['close', 'title', 'checklistColumnHeader', 'descriptionColumnHeader', 'items', 'submitButtonText', 'modalSize'];
    constructor(close, title, checklistColumnHeader, descriptionColumnHeader, items, submitButtonText, modalSize) {
        this.close = close;
        this.title = title;
        this.checklistColumnHeader = checklistColumnHeader;
        this.descriptionColumnHeader = descriptionColumnHeader;
        this.items = items;
        this.submitButtonText = submitButtonText;
        this.modalSize = modalSize;
        this.handleCheckboxChanged = (event) => {
            const { id } = event.target;
            const item = this.getItemById(id);
            if (!item || item.disabled) {
                return;
            }
            const checked = event.srcElement.checked;
            item.checked = checked;
        };
        this.handleCheckAllChanged = (event) => {
            const checked = event.srcElement.checked;
            if (!checked && !this.isAllAvailableChecked) {
                return;
            }
            this.availableItems.map(item => item.checked = checked);
        };
        this._close = this.close;
    }
    cancel() {
        this.close();
    }
    submit() {
        this.close(this.availableCheckedItems);
    }
    get availableCheckedItems() {
        return this.availableItems.filter(item => item.checked);
    }
    getItemById(id) {
        const [item] = this.items.filter(item => item.id == id);
        return item;
    }
    get isAllAvailableChecked() {
        return this.availableItems.every(item => item.checked);
    }
    get availableItems() {
        return this.items.filter(item => !item.disabled);
    }
    get isSubmitButtonDisabled() {
        return !this.hasAnyAvailableChecked;
    }
    get hasAnyAvailableChecked() {
        return this.availableCheckedItems.length > 0;
    }
}
ChecklistModalController.$inject = ['close', 'title', 'checklistColumnHeader', 'descriptionColumnHeader', 'items', 'submitButtonText', 'modalSize'];
export default ChecklistModalController;
